import { render, staticRenderFns } from "./stageItemForm.vue?vue&type=template&id=67393609"
import script from "./stageItemForm.vue?vue&type=script&lang=js"
export * from "./stageItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports